<template>
    <!-- 问卷结果页 -->
    <div class="do-questionnaire-result">
        <div class="header">
            <Header/>
        </div>
        <div class="app-width content">
            <img src="@/assets/img/psq/questionnaire-result.png"
                 alt="questionnaire-result"/>
            <div class="text-desc">问卷到此结束，感谢您的参与</div>
            <el-button type="primary"
                       v-if="parseInt($route.query.isViewResult) === 1"
                       @click.stop="viewStatAnalyse"
                       style="display: block; width: 80%; margin: 0 auto">查看问卷统计分析</el-button>
            <el-button type="primary"
                       plain
                       v-if="$store.state.user"
                       @click.stop="backToPersonCenter"
                       style="display: block; width: 80%; margin: 20px auto 0">返回个人中心</el-button>
        </div>
    </div>
</template>

<script>
import Header from "@/components/header";
export default {
    name: "DoQuestionnaireResult",
    components: {
        Header
    },
    methods: {
        backToPersonCenter () {
            this.$router.push("/personCenter/questionnaire")
        },
        viewStatAnalyse () {
            this.$router.push({
                name: "QuestionAnalyse",
                query: {
                    Qid: this.$route.query.Qid,
                    from: this.$route.query.from
                }
            })
        }
    }
}
</script>

<style scoped>
.content {
    background-color: #fff;
    padding: 100px 60px;
    text-align: center;
    box-sizing: border-box;
}
.header {
    height: 70px;
}
.text-desc {
    font-size: 20px;
    font-weight: 500;
    margin: 40px 0;

}
</style>
